import * as tslib_1 from "tslib";
import { lazyGetServerOptionsForFeature, OwsOptionsFeatureType, } from 'owa-outlook-service-options';
export default function loadGdprAdConsentString() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var getServerOptionsForFeature, response;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, lazyGetServerOptionsForFeature.import()];
                case 1:
                    getServerOptionsForFeature = _a.sent();
                    return [4 /*yield*/, getServerOptionsForFeature(OwsOptionsFeatureType.GdprAdsPrefs)];
                case 2:
                    response = _a.sent();
                    if (response == null) {
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/, response.consentString];
            }
        });
    });
}
//# sourceMappingURL=loadGdprAdConsentString.js.map